module.exports = __webpack_public_path__ + "images/c05449525c88e973450161fc440680eb.png";